// @flow

import { connect } from 'react-redux';
import Navigation from './navigation';
import { changeProfile } from '../../services/authentication';
import { User } from '../../models/user';
import {
  openHamburgerMenu,
  closeHamburgerMenu,
  openProfileMenu,
  closeProfileMenu,
} from '../../services/ui';

export type Props = {
  user: User,
  changeProfile: (ProfileId: string) => void,
  authenticating: boolean,
  showModalBlur: boolean,
};

const mapState = ({ authentication, ui }) => ({
  user: authentication.user,
  authenticating: authentication.authenticating,
  showModalBlur: ui.showModalBlur,
  showMainMenu: ui.showMainMenu,
  showProfileMenu: ui.showProfileMenu,
});

const mapDispatch = {
  changeProfile,
  openHamburgerMenu,
  closeHamburgerMenu,
  openProfileMenu,
  closeProfileMenu,
};

export default connect(
  mapState,
  mapDispatch,
)(Navigation);
